<div *ngIf="errorLoadingVideos; else videoList">
    <p>Visita nuestro canal de YouTube para no perderte nuestros mejores vídeos.</p>
    <div class="iframe-container">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/videoseries?si=KZo5yuCFAs_XgDCy&amp;list=PLnfcR2VaKMUDEHxC6w8PJHBHsZBhMMtXp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
</div>
<ng-template #videoList>
    <div class="iframe-container">
        <iframe
            *ngIf="videos[0]" 
            [src]="'https://www.youtube.com/embed/' + videos[0].videoId | safeUrl" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen>
        </iframe>
    </div>
    <div class="spacer"></div>
    <p-carousel
      *ngIf="videos.length > 0"
      [value]="videos | slice:1:9"
      [responsiveOptions]="responsiveOptions"
      [numVisible]="3"
      [circular]="true"
      autoplayInterval="3000"
      class="custom-carousel"
    >
      <ng-template let-video let-index="index" pTemplate="item">
        <div class="video-item">
            <a [href]="'https://www.youtube.com/watch?v=' + video.videoId" target="_blank">
              <div class="thumbnail-container">
                <img [src]="video.thumbnail" [alt]="video.title" class="thumbnail" />
              </div>
              <p class="video-title">{{ video.title }}</p>
            </a>
        </div>
      </ng-template>
    </p-carousel>
</ng-template>
  